export default __webpack_public_path__ + "static/media/google-map.8a71fd6f.jpg";